<div (window:resize)="onResize($event)">
    <ng-container *ngIf="!showQuestionsTabContent">
        <div class="loading text-center">
            <br />
            <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
            <br />
            <p>Loading questions, please wait...</p>
        </div>
    </ng-container>


    <ng-container *ngIf="showQuestionsTabContent">

        <ul class="nav nav-tabs">
            <li (click)="tabSelected(1.1)" class="active"><a data-toggle="tab" href="#questions">Questions</a></li>
            <li (click)="tabSelected(1.2)"><a data-toggle="tab" href="#choices">Choice sets</a></li>
        </ul>

        <div class="tab-content">
            <div id="questions" class="tab-pane fade in active">

                <div class="container-fluid">
                    <div class="row">
                        <div>
                            <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                                <h1 class="h3 mb-0 text-gray-800"></h1>
                                <div class="btns-container">
                                    <div>
                                        <a (click)="deleteSelected()" class="d-none d-sm-inline-block btn btn-sm shadow-sm" [ngClass]="{'btn-red': canDelete, 'btn-gray': !canDelete}">
                                            <i class="fas fa-trash text-white-50"> <span class="button-text"> Delete</span></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--<div class="col-sm-9 table-actions">
         <div (click)="editSelected()" [ngClass]="{'icon_disabled': canEdit == false}">
            <i class="material-icons" [ngClass]="{'icon_disabled': canEdit == false}">edit</i>
            <span>Edit</span>
        </div>

        <div (click)="deleteSelected()" [ngClass]="{'icon_disabled': canDelete == false}">
            <i class="material-icons" [ngClass]="{'icon_disabled': canDelete == false}">delete</i>
            <span>Delete</span>
        </div>
    </div>-->

                        <div class="col-sm-3 text-right table-actions-buttons topSpacingBtn">
                            <a (click)="openModal('create')" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                                <i class="fas fa-plus text-white-50"> <span class="button-text">Create Question</span></i>
                            </a>
                        </div>

                    </div>
                </div>

                <div>
                    <div class="table-responsive" style="width: 100%; max-height: 400px; height:400px;">
                        <ag-grid-angular #agGrid
                                         style="width: 100%; height: 100%;"
                                         class="ag-theme-balham"
                                         [enableFilter]="true"
                                         [floatingFilter]="true"
                                         [gridOptions]="gridOptions"
                                         [rowData]="questions"
                                         [columnDefs]="questionsHeaders"
                                         [enableSorting]="true"
                                         [enableColResize]="true"
                                         (rowClicked)="onRowClickedQuestions($event)"
                                         (gridReady)="onGridReadyQuestions($event)"
                                         [pagination]="true"
                                         [paginationPageSize]="25"
                                         [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                         [rowSelection]="rowSelection"
                                         (rowSelected)="onRowSelected($event)"
                                         (selectionChanged)="onSelectionChanged($event)"
                                         [rowMultiSelectWithClick]="true"
                                         [suppressRowClickSelection]="true">
                        </ag-grid-angular>
                    </div>
                </div>
            </div>

            <div id="choices" class="tab-pane fade">

                <ng-container *ngIf="!showChoicesTabContent">
                    <div class="loading text-center">
                        <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="color:#46a8ce; font-size: 75px;"></i>
                        <p>Loading, please wait...</p>
                    </div>
                </ng-container>

                <ng-container *ngIf="showChoicesTabContent">

                    <div class="container-fluid">
                        <div class="row">
                            <div>
                                <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                                    <h1 class="h3 mb-0 text-gray-800"></h1>
                                    <div class="btns-container">
                                        <div>
                                            <a (click)="deleteSelectedChoiceSet()" class="d-none d-sm-inline-block btn btn-sm shadow-sm" [ngClass]="{'btn-red': canDeleteChoiceSet, 'btn-gray': !canDeleteChoiceSet}">
                                                <i class="fas fa-trash text-white-50"> <span class="button-text"> Delete</span></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--<div class="col-sm-9 table-actions">
         <div (click)="editSelectedChoiceSet()" [ngClass]="{'icon_disabled': canEditChoiceSet == false}">
            <i class="material-icons" [ngClass]="{'icon_disabled': canEditChoiceSet == false}">edit</i>
            <span>Edit</span>
        </div>

        <div (click)="deleteSelectedChoiceSet()" [ngClass]="{'icon_disabled': canDeleteChoiceSet == false}">
            <i class="material-icons" [ngClass]="{'icon_disabled': canDeleteChoiceSet == false}">delete</i>
            <span>Delete</span>
        </div>
    </div>-->


                            <div class="col-sm-3 text-right table-actions-buttons topSpacingBtn">
                                <a (click)="createChoiceSet()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                                    <i class="fas fa-plus text-white-50"> <span class="button-text">Create Choice set</span></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    
                    <div>
                        <div style="width: 100%; max-height: 400px; height:400px;">
                            <ag-grid-angular #choiceSetgrid
                                             style="width: 100%; height: 100%;"
                                             class="ag-theme-balham"
                                             [enableFilter]="false"
                                             [floatingFilter]="true"
                                             [gridOptions]="gridOptions"
                                             [rowData]="choiceSet"
                                             [columnDefs]="choiceSetHeaders"
                                             [enableSorting]="false"
                                             [enableColResize]="false"
                                             (rowClicked)="onRowClickedChoiceSet($event)"
                                             (gridReady)="onGridReadyChoiceSet($event)"
                                             [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                             [pagination]="false"
                                             [rowSelection]="rowSelection"
                                             (rowSelected)="onRowSelected($event)"
                                             (selectionChanged)="onSelectionChangedChoiceSet($event)"
                                             [rowMultiSelectWithClick]="true"
                                             [suppressRowClickSelection]="true">
                            </ag-grid-angular>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

    </ng-container>
</div>

<!--CHOICE SET MODAL-->
<div class="modal fade" id="section2ModalChoiceSet" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <div class="text-center">
                    <h2 class="modal-title text-center" id="ModalLabel">{{choiceSetAction}} Choice Set</h2>
                </div>
                <button (click)="closeChoiceSetModal()" type="button" class="close" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-12 col-md-1 noPadding">
                        <label>Name:</label>
                    </div>
                    <div class="col-md-11 noPadding">
                        <input class="" type="text" id="section2ChoiceSetName" value="{{choiceSetName}}" />
                    </div>
                </div>

                <br />

                <div class="row">
                    <div>
                        <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                            <h5>Choices</h5>
                            <!--<h1 class="h3 mb-0 text-gray-800"></h1>-->
                            <div class="btns-container">
                                <div>
                                    <a (click)="deleteSelectedChoices()" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-red': canDeleteChoices, 'btn-gray': !canDeleteChoices}">
                                        <i class="fas fa-trash text-white-50"> <span class="button-text"> Delete</span></i>
                                    </a>
                                    <a (click)="openChoiceModal('create')" class="d-none d-sm-inline-block btn btn-sm shadow-sm btn-primary">
                                        <i class="fas fa-plus text-white-50"> <span class="button-text"> Add choice</span></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--<div class="col-sm-9 table-actions">
         <div (click)="editSelectedChoices()" [ngClass]="{'icon_disabled': canEditChoices == false}">
            <i class="material-icons" [ngClass]="{'icon_disabled': canEditChoices == false}">edit</i>
            <span>Edit</span>
        </div>

        <div (click)="deleteSelectedChoices()" [ngClass]="{'icon_disabled': canDeleteChoices == false}">
            <i class="material-icons" [ngClass]="{'icon_disabled': canDeleteChoices == false}">delete</i>
            <span>Delete</span>
        </div>
    </div>-->
                    <!--<div class="col-sm-3 text-right table-actions-buttons">
        <button (click)="openChoiceModal('create')"
                type="button"
                class="btn btn-warning">
            Add choice
        </button>
    </div>-->
                </div>

                <div style="width: 100%; max-height: 400px; height:400px;">
                    <ag-grid-angular #choicesgrid
                                     style="width: 100%; height: 100%;"
                                     class="ag-theme-balham"
                                     [enableFilter]="false"
                                     [gridOptions]="gridOptions"
                                     [rowData]="choices"
                                     [columnDefs]="choicesHeaders"
                                     [enableSorting]="false"
                                     [enableColResize]="false"
                                     (rowClicked)="onRowClickedChoices($event)"
                                     (gridReady)="onGridReadyChoices($event)"
                                     [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                     [pagination]="false"
                                     [animateRows]="true"
                                     [rowDragManaged]="true"
                                     (rowDragEnter)="onRowDragEnter($event)"
                                     (rowDragEnd)="onRowDragEnd($event)"
                                     [rowSelection]="rowSelection"
                                     (rowSelected)="onRowSelected($event)"
                                     (selectionChanged)="onSelectionChangedChoices($event)"
                                     [rowMultiSelectWithClick]="true"
                                     [suppressRowClickSelection]="true">
                    </ag-grid-angular>

                </div>
            </div>


            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closeChoiceSetModal()">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="saveChoiceSet()">Save</button>
            </div>
        </div>
    </div>
</div>

<!--CHOICES MODAL-->
<div class="modal fade" id="section2ModalChoices" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <div class="text-center">
                    <h2 class="modal-title text-center"><span class="capitalize">{{action}}</span> section 2 choice</h2>
                </div>
                <button (click)="closeChoicesModal()" type="button" class="close" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-12 col-md-3 noPadding">
                        <label>Language:</label>
                    </div>
                    <div class="col-12 col-md-9 noPadding">
                        <select #languageShortCode id="section2LanguagesChoice" (change)="checkData(languageShortCode.value)">
                            <option *ngFor="let language of languages" [value]="language.ShortCode">{{language.Name}}</option>
                        </select>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-md-3 noPadding">
                        <label>Text:</label>
                    </div>
                    <div class="col-12 col-md-9 noPadding">
                        <textarea (focusout)="addLocalization(text.value, languageShortCode.value)"
                                  (keypress)="preventSpace(text.value, $event)"
                                  (keyup)="preventSpace(text.value, $event)"
                                  id="section2TextareaChoice" class="" #text placeholder="Question body" cols="2" rows="2">{{text}}</textarea>
                    </div>
                </div>

                <div class="row">
                    <br />
                    <div class="col-12">
                        <h6><b>Points</b></h6>
                    </div>
                    <br />
                </div>

                <div class="row">
                    <div class="col-12 col-md-3 noPadding">
                        <label>Positively keyed</label>
                    </div>
                    <div class="col-12 col-md-9 noPadding">
                        <input (keypress)="preventLetters($event)" (keyup)="preventSpace(text.value, $event)" type="number" min="0" name="name" value="{{positiveP}}" id="s2positive" />
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-md-3 noPadding">
                        <label>Negatively keyed</label>
                    </div>
                    <div class="col-12 col-md-9 noPadding">
                        <input (keypress)="preventLetters($event)" (keyup)="preventSpace(text.value, $event)" type="number" min="0" name="name" value="{{negativeP}}" id="s2negative" />
                    </div>
                </div>
            </div>


            <div class="modal-footer">
                <input (click)="closeChoicesModal()" type="button" class="btn btn-secondary" name="close" value="Cancel" />
                <input type="button" (click)="saveChoice()" class="btn btn-primary waves-effect" value="Save" />
            </div>
        </div>
    </div>
</div>

<app-new-satisfaction-modal #newsatisfaction></app-new-satisfaction-modal>
<!--<app-new-satisfaction-choice-modal #newsatisfactionchoice></app-new-satisfaction-choice-modal>-->